/**
 * @generated SignedSource<<66bbf1013682335db9365a9df979ad97>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCustomerOrg_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly customerOrgLastActivity?: {
      readonly event: string | null;
      readonly lastActivityAt: string | null;
    } | null;
    readonly displayName?: string | null;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly parent?: {
      readonly displayName?: string | null;
      readonly id?: string;
    } | null;
  } | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCustomerOrg_AtlassianSearchPage";
};
export type searchGraphCustomerOrg_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCustomerOrg_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCustomerOrg_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCustomerOrg_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*: any*/),
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "owners",
              "plural": true,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    (v4/*: any*/)
                  ],
                  "type": "ExternalCustomerOrg"
                }
              ]
            },
            {
              "concreteType": "ExternalCustomerOrgLastActivity",
              "kind": "LinkedField",
              "name": "customerOrgLastActivity",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "lastActivityAt"
                },
                {
                  "kind": "ScalarField",
                  "name": "event"
                }
              ]
            }
          ],
          "type": "ExternalCustomerOrg"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "3ed05421c616e83da42270f6b7981f84";

export default node;
